const styles = `.activeIndicator {
  background: var(--goto-surface-color-brand-default);
  border-radius: 4px 4px 0 0;
  margin-top: var(--goto-spacing-00);
}

:host .tablist {
  align-self: inherit;
  margin-top: calc(var(--goto-spacing-01) / 2);
}
:host .start,
:host .end {
  margin-top: var(--goto-spacing-02);
}

:host(.full-width),
:host(.full-width) .tablist {
  width: 100%;
}`; export default styles;